@if (node$ | async; as node) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (!embedded) {
        <mat-toolbar elderTheme color="primary" class="layout-row gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: node }"
          ></ng-template>
        </mat-toolbar>
      } @else {
        <div class="layout-row place-start-center gap-md flex p-md">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: node }"
          ></ng-template>
        </div>
      }
    </div>
    <!-- Content -->
    <div class="layout-col flex">
      <mat-tab-group class="flex" animationDuration="0ms">
        <!-- Tab Overview -->
        <mat-tab label="{{ 'context.overview' | translate }}" class="flex">
          <elder-basic-pane-layout>
            <!-- General -->
            <elder-pane>
              <elder-pane-header>
                <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
                <elder-pane-actions>
                  <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
                    <mat-icon>save</mat-icon>
                  </button>
                  <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onDelete($event)" [disabled]="!deletionEnabled">
                      <mat-icon>delete</mat-icon>
                      <span>{{ 'actions.delete' | translate }}</span>
                    </button>
                  </mat-menu>
                </elder-pane-actions>
              </elder-pane-header>
              <elder-pane-content class="layout-col flex">
                <form #mainFrm="ngForm" class="layout-col flex">
                  <div class="layout-col gap-md">
                    <!-- Identification -->
                    <div class="layout-col">
                      <elder-pane-subtitle>
                        {{ 'context.identification' | translate }}
                      </elder-pane-subtitle>
                      <div class="layout-row place-start-center gap-md">
                        <mat-form-field>
                          <mat-label>{{ 'context.path' | translate }}</mat-label>
                          <input
                            matInput
                            name="path"
                            required
                            [ngModel]="node.ancestors"
                            readonly
                          />
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>{{ 'context.number' | translate }}</mat-label>
                          <input
                            matInput
                            name="number"
                            required
                            [readonly]="!creationMode"
                            [(ngModel)]="node.number"
                            #numberModel="ngModel"
                          />
                          @if (numberModel.errors?.['required']) {
                            <mat-error>{{ 'validations.required' | translate }}</mat-error>
                          }
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>{{ 'context.type' | translate }}</mat-label>
                          <elder-select
                            appStorageNodeTypeSelect
                            name="type"
                            required
                            [readonly]="!creationMode"
                            valueAsId
                            [(ngModel)]="node.type"
                            #storageTypeModel="ngModel"
                          >
                          </elder-select>
                          @if (storageTypeModel.errors?.['required']) {
                            <mat-error>{{ 'validations.required' | translate }}</mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="layout-row place-start-center gap-md">
                        <mat-form-field>
                          <mat-label>{{ 'context.description' | translate }}</mat-label>
                          <input matInput name="description" [(ngModel)]="node.description" />
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>{{ 'context.priority' | translate }}</mat-label>
                          <input
                            matInput
                            name="priority"
                            type="number"
                            [(ngModel)]="node.priority"
                          />
                        </mat-form-field>
                        <mat-slide-toggle name="activated" [(ngModel)]="node.activated">
                          {{ 'context.activated' | translate }}
                        </mat-slide-toggle>
                      </div>
                    </div>
                    <!-- Capacity -->
                    <div class="layout-col">
                      <elder-pane-subtitle>{{
                        'context.capacity' | translate
                      }}</elder-pane-subtitle>
                      <div class="layout-row place-start-center gap-md">
                        <mat-form-field>
                          <mat-label>{{ 'storage.minWeight' | translate }}</mat-label>
                          <elder-quantity-input
                            name="minWeight"
                            [(ngModel)]="node.capacity.minWeight"
                          >
                          </elder-quantity-input>
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>{{ 'storage.maxWeight' | translate }}</mat-label>
                          <elder-quantity-input
                            name="maxWeight"
                            [(ngModel)]="node.capacity.maxWeight"
                          >
                          </elder-quantity-input>
                        </mat-form-field>
                        <mat-slide-toggle
                          name="multiOrderModeEnabled"
                          [matTooltip]="'storage.multiOrderModeEnabledDescription' | translate"
                          [(ngModel)]="node.capacity.multiOrderModeEnabled"
                        >
                          {{ 'storage.multiOrderModeEnabled' | translate }}
                        </mat-slide-toggle>
                      </div>
                      <div class="layout-row place-start-center gap-md">
                        <mat-form-field>
                          <mat-label>{{ 'dimensions.title' | translate }}</mat-label>
                          <elder-dimensions-input
                            name="dimensions"
                            [(ngModel)]="node.capacity.dimensions"
                          >
                          </elder-dimensions-input>
                        </mat-form-field>
                        <mat-form-field>
                          <mat-label>{{
                            'storage.packageCheckinMode.title' | translate
                          }}</mat-label>
                          <elder-select
                            appPackageCheckinModeSelect
                            name="packageCheckinMode"
                            required
                            valueAsId
                            [(ngModel)]="node.packageCheckinMode"
                            #checkinModeModel="ngModel"
                          >
                          </elder-select>
                          @if (checkinModeModel.errors?.['required']) {
                            <mat-error>{{ 'validations.required' | translate }}</mat-error>
                          }
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </form>
              </elder-pane-content>
            </elder-pane>
          </elder-basic-pane-layout>
        </mat-tab>
        <!-- Tab Assignment -->
        <mat-tab [disabled]="creationMode">
          <ng-template matTabLabel>
            <span>{{ 'storage.assignment' | translate }}</span>
          </ng-template>
          <ng-template matTabContent>
            <app-storage-node-assignment class="flex" [node]="node$ | async">
            </app-storage-node-assignment>
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
}

<ng-template #header let-node>
  @if (!creationMode) {
    <elder-header [header]="node.path" [subheader]="'ID: ' + node.id"> </elder-header>
  } @else {
    <span>
      {{ 'storage.new' | translate }}
    </span>
  }
</ng-template>
